<template>
  <div id="search-wrapper" :class="isShow && 'box-style'" @click.stop="0">
    <div class="input-box">
      <div class="input-wrap d-flex">
        <v-icon class="search-icon">mdi-magnify</v-icon>
        <v-text-field v-model="keywords" :rules="rules" :label="$TL.searchPlaceholder" hide-details="auto" type="search" class="search-control" @click="ifShow = isShow = true" @keyup.enter="search_submit"></v-text-field>
        <v-btn class="clear-btn" v-show="isClearBtn" @click="keywords = ''">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn class="close-btn" @click="isShow = !isShow">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="search-filter-box border-top" v-show="isShow">
      <div class="search-content ">
        <div class="language-box">
          <span class="label">{{ $TL.byLanguage }}</span>

          <div class="search-type-select d-flex">
            <v-checkbox v-model="languageSelect.selected" :label="$TL.allLanguage" value="all"></v-checkbox>
            <v-checkbox v-model="languageSelect.selected" :label="$TL.currentLanguage" :value="$store.state.global.currentLang.lang"></v-checkbox>
            <v-checkbox v-model="languageSelect.selected" :label="$TL.anyLanguage" value="none"></v-checkbox>
          </div>
        </div>
        <div class="updatetime-box">
          <span class="label">{{ $TL.byDate }}</span>
          <div class="search-type-select">
            <v-select v-model="updateTimeSelect.selected" :items="updateTimeSelect.items" item-text="state" item-value="abbr" attach @input="format_date" />
          </div>
        </div>
        <div class="custom-date-pickers" v-if="isCustomDate">
          <div class="date-pickers d-flex">
            <span class="label">{{$TL.timeInterval}}</span>
            <v-menu ref="startMenu" class="start-menu" :close-on-content-click="true" offset-y transition="scale-transition" attach>
              <template v-slot:activator="{ on }">
                <v-text-field ref="startField" v-model="start" clearable label="Start date" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="start" no-title>
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
            <v-menu ref="endMenu" class="end-menu" :close-on-content-click="true" offset-y transition="scale-transition" attach>
              <template v-slot:activator="{ on }">
                <v-text-field v-model="end" clearable ref="endField" label="End date" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="end" no-title>
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="type-box">
          <span class="label">{{ $TL.byCategory }}</span>
          <div class="categray-box">
            <v-menu offset-y attach :close-on-content-click="closeType">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="cate" v-bind="attrs" v-on="on" @click="open_select">
                  {{ categrayTips }}
                </v-btn>
              </template>
              <search-categray ref="searchCategray" @updateCategory="update_category" />

            </v-menu>
          </div>
        </div>

        <div class="search-fn-control d-flex justify-content-end">
          <v-btn class="reset-btn" @click="reset_param">{{ $TL.reset }}</v-btn>
          <v-btn class="submit-btn gradient-bg" @click="search_submit">{{
              $TL.search
            }}</v-btn>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import searchCategray from "@/components/search-categray/index";
import { get_days, timeout, get_storage } from "@/utils/util.js";

export default {
  name: "search",
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      rules: [
        (value) => !!value || this.is_clear_btn(false),
        (value) => !value || this.is_clear_btn(true),
      ],
      languageSelect: {
        selected: [],
      },
      updateTimeSelect: {
        selected: { abbr: "unTime" },
        items: [
          { state: this.$TL.unlimitedDate, abbr: "unTime" },
          { state: this.$TL.today, abbr: "todayTime" },
          { state: this.$TL.lastDay7, abbr: "weekTime" },
          { state: this.$TL.lastDay30, abbr: "monthTime" },
          { state: this.$TL.customize, abbr: "customTime" },
        ],
      },
      dates: [],
      ifShow: 1,
      isShow: false,
      closeType: false,
      isClearBtn: false,
      keywords: "",
      folderIds: [],
      start: "",
      end: "",
      fnames: [],
      isCustomDate: false,
      categrayTips: this.$TL.anyLocation,
    };
  },
  components: { searchCategray },
  computed: {
    ...mapState("global", ["currentLang"]),
    ...mapState("search", ["searchCondition"]),
    ...mapState("triggerEvtents", ["clearSearchCondition"]),
    ...mapGetters("global", ["globalMainMenu"]),
  },
  watch: {
    clearSearchCondition(newData) {
      this.reset_param();
      this.keywords = "";
    },
  },
  created() {
    this.assign_search_defaults();
  },
  mounted() {
    document.addEventListener("click", () => {
      this.isShow = false;
    });
  },
  beforeDestroy() {},
  methods: {
    ...mapMutations("search", ["updateSearchCondition"]),
    ...mapMutations("triggerEvtents", [
      "updateGetSchemaData",
      "updateInitSearchCondition",
    ]),
    is_clear_btn(blon) {
      this.isClearBtn = blon;
      return blon;
    },

    format_date() {
      let select = this.updateTimeSelect.selected;
      let oNow = new Date();
      this.isCustomDate = false;

      switch (select) {
        case "unTime":
          this.start = "";
          break;
        case "todayTime":
          this.start = new Date().Format("yyyy-MM-dd");
          break;
        case "weekTime":
          //  一周时间差的毫秒数 计算公式： 7*24*3600*1000
          let weekdateDiff = 604800000;
          this.start = new Date(oNow.getTime() - weekdateDiff).Format(
            "yyyy-MM-dd"
          );
          break;
        case "monthTime":
          let monthdateDiff = get_days() * 24 * 3600 * 1000;
          this.start = new Date(oNow.getTime() - monthdateDiff).Format(
            "yyyy-MM-dd"
          );
          break;
        case "customTime":
          this.start = new Date().Format("yyyy-MM-dd");
          this.isCustomDate = true;
          break;
        default:
          break;
      }
    },

    search_submit() {
      // if (String(this.keywords).trim().length < 1) return;
      //  如果用户在收藏页或收藏详情页
      this.$P.returnIndex(this);

      this.updateInitSearchCondition();
      this.$P.schemaType = "search";
      this.updateSearchCondition({
        fnames: this.fnames,
        keyword: String(this.keywords).trim(),
        start: this.start,
        end: this.end,
        lang: this.languageSelect.selected,
      });

      this.updateGetSchemaData();
      this.isShow = false;
    },

    update_category(namesArry) {
      this.fnames = namesArry;
      this.update_category_tips(namesArry);
    },

    update_category_tips(array) {
      if (array.length > 1) {
        this.categrayTips = this.$TL.limitedCategory;
      } else if (array.length === 1) {
        this.categrayTips = array[0];
      } else {
        this.categrayTips = this.$TL.anyLocation;
      }
    },

    reset_param() {
      this.assign_search_defaults();
      this.updateTimeSelect.selected = { abbr: "unTime" };
      this.isCustomDate = false;
      this.start = this.end = "";
      this.categrayTips = this.$TL.anyLocation;
      this.$refs.searchCategray?.close_select();
    },

    async open_select() {
      this.closeType = false;
      await timeout(200);
      this.$refs.searchCategray.open_select();
    },

    //  按角色选择默认搜索语言
    assign_search_defaults() {
      let role = get_storage("user-role");
      this.languageSelect.selected =
        role === "user-meigong"
          ? ["all", "none"]
          : [this.$store.state.global.currentLang.lang, "none"];
    },
  },
};
</script>

<style lang="scss">
#search-wrapper {
  width: 100%;
  background-color: $color-white;
  border-radius: $border-radius;
  position: absolute;
  left: 0;
  top: 0;

  padding: {
    left: 18px;
    right: 28px;
  }

  .search-content {
    padding: 10px 0 26px 0;

    .v-messages,
    .v-text-field__details {
      display: none;
    }
  }

  i {
    color: #8f8f8f;
  }

  .border-btm {
    border-bottom: 1px solid rgba(#707070, 0.3);
  }

  .border-top {
    border-top: 1px solid rgba(#707070, 0.3);
  }

  .search-filter-box {
    background-color: $color-white;
    padding-left: 16px;
    margin-top: 4px;
  }

  .input-box {
    .input-wrap {
      align-items: center;
      position: relative;
      height: 40px;

      .search-icon {
        padding: 0;
        font-size: 26px;
        color: #dfe1e5;
      }

      .clear-btn {
        padding: 0;
        border-radius: 50%;
        padding: 4px;
        flex-shrink: 0;
        width: 20px;
        height: 20px;

        i {
          font-size: 16px;
        }
      }

      .close-btn {
        margin-right: -10px;
        transition: all 0.35s ease;
        border-radius: 50%;
        height: 34px;
        width: 34px;
        flex-shrink: 0;

        &:active {
          background-color: rgba(0, 0, 0, 0.14);
        }
      }

      .v-input__slot {
        padding-left: 8px;

        &::before,
        &::after {
          display: none;
        }

        .v-label {
          position: absolute !important;
          color: rgba(0, 0, 0, 0.6) !important;
          font-size: 15px;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }

      input {
        width: 100%;
        padding: 2px 0;
        line-height: 1.5;
        font-size: 15px;
        border: 0;
        -webkit-appearance: none;

        &:focus {
          outline: none;
        }

        &::-webkit-search-decoration {
          -webkit-appearance: none;
        }

        &::-webkit-search-cancel-button {
          display: none;
        }
      }
    }
  }

  .label {
    display: inline-block;
    flex-shrink: 0;
    font-size: 14px;
    color: #707070;
  }

  .language-box {
    .search-type-select {
      .v-input {
        margin-right: 16px;

        .v-input--selection-controls__input {
          margin-right: 0;
        }
        .v-label {
          font-size: 15px;
          color: $color-font;
        }
      }
    }
  }

  .language-box,
  .updatetime-box,
  .custom-date-pickers,
  .type-box {
    margin-top: 16px;
    @include flex(center);
  }

  .language-box,
  .updatetime-box {
    .search-type-select {
      width: 100%;
      position: relative;
      margin-left: 16px;

      .v-input__slot {
        &:before {
          opacity: 0.42;
        }

        .v-select__selections {
          min-height: 32px;
        }
      }

      .v-select__slot {
        width: 100%;

        label,
        .v-select__selection {
          font-size: 14px;
          color: $color-font;
        }
      }

      .v-menu__content {
        min-width: 200px !important;
        width: 200px;
      }
    }
  }

  .updatetime-box .v-select__slot,
  .language-box .v-label {
    padding-left: 4px;
  }

  .custom-date-pickers {
    .v-input {
      margin-left: 18px;
    }
    .v-input__prepend-outer {
      margin: {
        top: 0;
        bottom: 0;
      }
    }

    .v-input__control {
      .v-label {
        position: absolute !important;
        z-index: 0;
        top: 2px;
        font-size: 14px;
      }

      input {
        position: relative;
        z-index: 2;
        padding: 3px 0;
        font-size: 14px;
      }

      .mdi-close {
        font-size: 16px;
      }
    }
  }

  .submit-btn{
    background-color: #2783e4;
    span {
      color: $color-white;
    }
  }

  .search-fn-control {
    width: 100%;
    margin-top: 24px;
  }

  .reset-btn,
  .submit-btn{
    padding: 7px 16px;
    border-radius: 32px;
    margin-left: 8px;
  }
}
</style>
